/**
 * Account pages — membership cancel/resume buttons (now on /account/settings).
 *
 * The old JS tab switching and past-event toggles are gone: the dashboard is
 * separate server-rendered pages, and the remaining account widgets (free
 * ticket banner, "Show past" toggles) live in fa-core's dashboard.min.js,
 * which AccountController loads on those pages.
 */
export default function setupDashboard() {
  setupMembershipToggle()
}

/**
 * Wire #membership-cancel-btn and #membership-resume-btn — both share the
 * same shape: confirm → POST {data-action} with SecurityID → reload page.
 * Stripe takes a moment to send the webhook back, but our controller
 * mirrors the local Subscription.CancelAtPeriodEnd synchronously, so the
 * reload renders the new state immediately.
 */
function setupMembershipToggle () {
  const buttons = [
    document.getElementById('membership-cancel-btn'),
    document.getElementById('membership-resume-btn'),
  ].filter(Boolean)
  if (!buttons.length) return

  buttons.forEach(btn => {
    btn.addEventListener('click', async () => {
      const action = btn.dataset.action
      const confirmMsg = btn.dataset.confirm || 'Are you sure?'
      const securityId = btn.dataset.securityId || ''
      if (!action || !window.confirm(confirmMsg)) return

      const originalLabel = btn.textContent
      btn.disabled = true
      btn.textContent = 'Working…'

      try {
        const res = await fetch(action, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
          },
          body: 'SecurityID=' + encodeURIComponent(securityId),
        })
        const data = await res.json().catch(() => ({}))
        if (res.ok && data && data.success) {
          window.location.reload()
          return
        }
        const msg = (data && data.error) || 'Sorry, something went wrong. Please try again.'
        window.alert(msg)
      } catch (err) {
        window.alert('Sorry, something went wrong. Please try again.')
      }
      btn.disabled = false
      btn.textContent = originalLabel
    })
  })
}
